module.exports = __webpack_public_path__ + "assets/0b279f16cb8c26d62d194369c262c370.png";